import * as actions from "./../actions/actionTypes";
const initState = false;
const errorReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.ERROR:
      return action.payload;
    default:
      return state;
  }
};

export default errorReducer;
